export const projects = JSON.parse(sessionStorage.getItem("projects"));
export const customerName = sessionStorage.getItem("customerName");
export const structureItem = JSON.parse(
  sessionStorage.getItem("structureItem")
);

export const orientationList = [
  {
    orientation: "Landscape",
  },
  {
    orientation: "Portrait",
  },
];

export const roofStructureData = [
  {
    articleName: "BHSML101",
    name: "Smith L1",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 1,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 0,
    endClamp: 4,
    structureWatt: 1,
    shared: false,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith%20L1_1778481183071.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL1.png",
    layout1: "../images/diagram/smithL1-1.jpg",
    layout2: "../images/diagram/smithL1-2.jpg",
  },
  {
    articleName: "BHSML201",
    name: "Smith L2",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 2,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 2,
    endClamp: 4,
    structureWatt: 2,
    shared: false,
    maxLimit: 1.25,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith%20L2_1778481377401.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL2.png",
    layout1: "../images/diagram/smithL2-1.jpg",
    layout2: "../images/diagram/smithL2-2.jpg",
  },
  {
    articleName: "BHSML2P01",
    name: "Smith L2 Pro",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 2,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 2,
    endClamp: 4,
    structureWatt: 2,
    shared: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+L2+Pro_1778481841749.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL2Pro.png",
    layout1: "../images/diagram/smithL2Pro-1.png",
    layout2: "../images/diagram/smithL2Pro-2.png",
  },

  {
    articleName: "BHSML301",
    name: "Smith L3",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 3,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 4,
    endClamp: 4,
    structureWatt: 3,
    shared: false,
    maxLimit: 1.25,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+L3_1778481887346.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL3.png",
    layout1: "../images/diagram/smithL3-1.jpg",
    layout2: "../images/diagram/smithL3-2.jpg",
  },
  {
    articleName: "BHSML3P01",
    name: "Smith L3 Pro",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 3,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 4,
    endClamp: 4,
    structureWatt: 3,
    shared: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+L3+Pro_1778481965484.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL3.png",
    layout1: "../images/diagram/smithL3Pro-1.png",
    layout2: "../images/diagram/smithL3Pro-2.png",
  },
  {
    articleName: "BHSML3VP01",
    name: "Smith L3 V-Pro",
    roofType: "Flat Roof",
    orientation: "Landscape",
    rowFrame: 3,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 0,
    midClamp: 4,
    endClamp: 4,
    structureWatt: 3,
    shared: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith%20L3%20V-Pro_1778482006511.png",
    structureDataSheet: "../images/structureData/DataSheet/smithL3VPro.png",
    layout1: "../images/diagram/smithL3VPro-1.png",
    layout2: "../images/diagram/smithL3VPro-2.png",
  },

  {
    articleName: "BHSMP101",
    name: "Smith P1",
    roofType: "Flat Roof",
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 186,
    midClamp: 0,
    endClamp: 0,
    structureWatt: 1,
    shared: true,
    throughRail: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778483416420.png",
    structureDataSheet: "../images/structureData/DataSheet/smithP1.png",
    layout1: "../images/diagram/smithP1Top.png",
    layout2: "../images/diagram/smithP1-2.jpg",
  },
  {
    articleName: "BHSMP101",
    name: "Smith P1 Through Rail",
    roofType: "Flat Roof",
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 186,
    midClamp: 0,
    endClamp: 0,
    structureWatt: 1,
    shared: true,
    throughRail: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778484377108.png",
    structureDataSheet:
      "../images/structureData/DataSheet/smithP1ThroughRail.png",
    layout1: "../images/diagram/smithP1TR-1.png",
    layout2: "../images/diagram/smithP1TR-2.png",
  },
  {
    articleName: "BHSMP101",
    name: "Smith P1 with Perlin",
    roofType: "Flat Roof",
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 186,
    midClamp: 0,
    endClamp: 0,
    structureWatt: 1,
    shared: true,
    throughRail: true,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+P1+Through+Rail_1778484424381.png",
    structureDataSheet:
      "../images/structureData/DataSheet/smithP1WithPerlin.png",
    layout1: "../images/diagram/smithP1WP-1.png",
    layout2: "../images/diagram/smithP1WP-2.png",
  },
  {
    articleName: "BHSMP101",
    name: "Smith P1(1.5ft clearance)",
    roofType: "Flat Roof",
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 455,
    midClamp: 0,
    endClamp: 0,
    structureWatt: 1,
    shared: true,
    throughRail: false,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/undefined_1778483416420.png",
    structureDataSheet: "../images/structureData/DataSheet/smithP1.png",
    layout1: "../images/diagram/smithP1Top.png",
    layout2: "../images/diagram/smithP1456C-2.png",
  },

  {
    articleName: "BHSMP201",
    name: "Smith P2",
    roofType: "Flat Roof",
    orientation: "Portrait",
    rowFrame: 2,
    colFrame: 1,
    moduleSpacing: 25,
    frameSpacing: 25,
    frontHeight: 250,
    midClamp: 0,
    endClamp: 0,
    block: 3,
    structureWatt: 2,
    shared: true,
    throughRail: true,
    mountStructure: true,
    structureImage:
      "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+P2_1778484253645.png",
    structureDataSheet: "../images/structureData/DataSheet/smithP2.png",
    layout1: "../images/diagram/smithP2-1.png",
    layout2: "../images/diagram/smithP2-2.png",
  },

  {
    name: "Smith Pro L",
    width: 2.254,
    height: 1.158,
    gap: 0.025,
    price: 1200,
    midClamp: 0,
    endClamp: 0,
    orientation: "Landscape",
    rowFrame: 1,
    colFrame: 1,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+Pro+L_1778482053472.jpg",
    structureImgSrc: "./images/structureTransparent/ProL1.svg",
    structureParts: "../images/structureParts/smithProL.jpg",
    structureDataSheet: "../images/structureData/DataSheet/smithProL.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    layout1: "../images/diagram/smithProL-1.png",
    layout2: "../images/diagram/smithProL-2.png",
  },
  {
    name: "Smith Through Rail L",
    width: 2.254,
    height: 1.158,
    gap: 0.025,
    price: 1200,
    orientation: "Landscape",
    rowFrame: 1,
    colFrame: 1,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith%20Through%20Rail%20L_1778482118864.png",
    structureImgSrc: "./images/structureTransparent/ProL1.svg",
    structureParts: "../images/structureParts/throughRailProL.png",
    structureDataSheet: "../images/structureData/DataSheet/smithFullRail.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPL01",
    layout1: "../images/diagram/smithProL-1.png",
    layout2: "../images/diagram/smithProL-2.png",
  },
  {
    name: "Smith Pro P",
    width: 1.158,
    height: 2.254,
    gap: 0.025,
    price: 1200,
    midClamp: 0,
    endClamp: 0,
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith+Pro+P_1778482145043.jpg",
    structureImgSrc: "./images/structureTransparent/ProP1.svg",
    structureParts: "../images/structureParts/smithProP.jpg",
    structureDataSheet: "../images/structureData/DataSheet/smithProP.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPP01",
    layout1: "../images/diagram/smithProL-1.png",
    layout2: "../images/diagram/smithProL-2.png",
  },
  {
    name: "Smith Through Rail P",
    width: 1.158,
    height: 2.254,
    gap: 0.025,
    price: 1200,
    orientation: "Portrait",
    rowFrame: 1,
    colFrame: 1,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Smith%20Through%20Rail%20P_1778482182147.png",
    structureImgSrc: "./images/structureTransparent/ProP1.svg",
    structureParts: "../images/structureParts/throughRailProP.png",
    structureDataSheet: "../images/structureData/DataSheet/smithFullRail.png",
    structureWatt: 1,
    roofType: "Shed Roof",
    articleName: "BHSMPP01",
    layout1: "../images/diagram/smithProP-1.png",
    layout2: "../images/diagram/smithThroughRailP-1.png",
  },

  {
    name: "Customized",
    width: 1.158,
    height: 4.636,
    gap: 3.2,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    orientation: "Portrait",
    rowFrame: 2,
    colFrame: 1,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Carport_1778484289831.png",
    structureImgSrc: "../images/structureTransparent/customized1.svg",
    structureParts: "../images/icons/customized.webp",
    structureDataSheet: "../images/structureData/DataSheet/carport.png",
    structureWatt: 2,
    roofType: "Customized Roof",
    articleName: "BHSMC01",
    layout1: "../images/diagram/carport.png",
    layout2: "",
  },



  {
    name: "Single Carport",
    width: 4.632,
    height: 4.636,
    gap: 3.2,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    orientation: "Portrait",
    rowFrame: 2,
    colFrame: 4,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Carport_1778484289831.png",
    structureImgSrc: "../images/structureTransparent/carport.webp",
    structureParts: "../images/icons/customized.webp",
    structureDataSheet: "../images/structureData/DataSheet/carport.png",
    structureWatt: 8,
    roofType: "Carport",
    articleName: "BHSMC01",
    layout1: "../images/diagram/carport.png",
    layout2: "",
  },
  {
    name: "Double Carport",
    width: 4.632,
    height: 4.636,
    gap: 0,
    price: 112500,
    midClamp: 12,
    endClamp: 8,
    supportClamp: 16,
    rails: 4,
    beam: 2,
    polls: 6,
    feet: 4,
    nutBoltsLarge: 12,
    nutBoltsSmall: 24,
    orientation: "Portrait",
    rowFrame: 2,
    colFrame: 4,
    structureImage: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Carport_1778484289831.png",
    structureImgSrc: "../images/structureTransparent/carport.webp",
    structureParts: "../images/icons/customized.webp",
    structureDataSheet: "../images/structureData/DataSheet/carport.png",
    structureWatt: 8,
    roofType: "Carport",
    articleName: "BHSMC01",
    layout1: "../images/diagram/carport.png",
    layout2: "",
  },
];

export const roofType = [
  {
    roofType: "Flat Roof",
    roofImage: "./images/Solutions/flatRoof.jpeg",
  },
  {
    roofType: "Shed Roof",
    roofImage: "./images/Solutions/shedRoof.webp",
  },
  {
    roofType: "Customized Roof",
    roofImage: "./images/Solutions/customized.avif",
  },
  {
    roofType: "Carport",
    roofImage: "./images/Solutions/carport.jpeg",
  },
];

export const boqINFO = {
  "Smith L1": [
    {
      serialNo: "BHSML101",
      name: "Smith L1",
      val: "data.totalStructure",
      img: "./images/structureTransparent/L1update.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith L2": [
    {
      serialNo: "BHSML201",
      name: "Smith L2",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithL2.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith L2 Pro": [
    {
      serialNo: "BHSML201",
      name: "Smith L2 Pro",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithL2Pro.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],

  "Smith L3": [
    {
      serialNo: "BHSML301",
      name: "Smith L3",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithL3.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith L3 Pro": [
    {
      serialNo: "BHSML3P01",
      name: "Smith L3 Pro",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithL3Pro.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith L3 V-Pro": [
    {
      serialNo: "BHSML3VP01",
      name: "Smith L3 V-Pro",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithL3VPro.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],

  "Smith P1": [
    {
      serialNo: "BHSMP101",
      name: "Smith P1",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithP1.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith P1 Through Rail": [
    {
      serialNo: "BHSMPB01",
      name: "Smith P1 Through Rail",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithP1THroughRail.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],
  "Smith P1 with Perlin": [
    {
      serialNo: "BHSMPB01",
      name: "Smith P1 with Perlin",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithP1Perlin.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],

  "Smith P1(1.5ft clearance)": [
    {
      serialNo: "BHSMP101",
      name: "Smith P1(1.5ft clearance)",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithP1.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
  ],

  "Smith P2": [
    {
      serialNo: "BHSMP201",
      name: "Smith P2",
      val: "data.totalStructure",
      img: "../images/structure/strImg/smithP2.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Rafter%26Rail_1778490738287.png",
    },
    {
      serialNo: "BHSMP01",
      name: "Polls",
      val: "data.beam * 4",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/P2_Poll_1778489978228.png",
    },
    {
      serialNo: "BHSMF01",
      name: "Feet",
      val: "data.beam * 2",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/P2_Feet_1778489838369.png",
    },
    {
      serialNo: "BHSMHC01",
      name: "H-Clamp",
      val: "data.beam * 4",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/P2_H_Clamp_1778489812960.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rafter",
      val: "data.beam",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Rafter%26Rail_1778490738287.png",
    },
    {
      serialNo: "BHSMJ01",
      name: "Jointer",
      val: "data.jointer",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Jointer_1778490671045.png",
    },
    {
      serialNo: "BHSMPC01",
      name: "Purllin Clamp",
      val: "data.beam * 8",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/P2_Purlin_Clamp_1778488911200.png",
    },
    {
      serialNo: "BHSMBM1201",
      name: "Bolts M8 70mm",
      val: "data.beam * 8",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/Bolt_1778489938458.png",
    },
    {
      serialNo: "BHSMFW01",
      name: "Foot Washer",
      val: "data.beam * 8",
      img: "https://smithpvx.s3.ap-southeast-1.amazonaws.com/P2_Foot_Washer_1778489885913.png",
    },
  ],

  "Smith Pro P": [
    {
      serialNo: "BHSMP201",
      name: "Smith Pro P",
      val: "data.totalStructure",
      img: "./images/structureParts/smithProP.jpg",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.midClamp + data.endClamp",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Smith%20Pro%20P_1755682681874.jpg",
    },
  ],
  "Smith Pro L": [
    {
      serialNo: "BHSMP201",
      name: "Smith Pro L",
      val: "data.totalStructure",
      img: "./images/structureParts/smithProL.jpg",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.midClamp + data.endClamp",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Smith%20Pro%20L_1755682669611.jpg",
    },
  ],
  "Smith Through Rail L": [
    {
      serialNo: "BHSMP201",
      name: "Smith Through Rail L",
      val: "data.totalStructure",
      img: "./images/structureParts/throughRailProL.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Rail_1755682500626.png",
    },
  ],
  "Smith Through Rail P": [
    {
      serialNo: "BHSMP201",
      name: "Smith Through Rail P",
      val: "data.totalStructure",
      img: "./images/structureParts/throughRailProP.png",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Rail_1755682500626.png",
    },
  ],

  //customized
  Customized: [
    {
      serialNo: "BHSMP201",
      name: "Customized",
      val: "data.totalStructure",
      img: "./images/icons/customized.webp",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMP01",
      name: "Polls",
      val: "data.polls",
      img: "../images/structureParts/polls.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength.toFixed(2)",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Rail_1755682500626.png",
    },
    {
      serialNo: "BHSMB01",
      name: "Beam",
      val: "data.beam",
      img: "../images/structureParts/beam.png",
    },
    {
      serialNo: "BHSMZC01",
      name: "Z Clamps",
      val: "data.beam * 12",
      img: "../images/structureParts/supportclamp.png",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 8mm)",
      val: "data.beam * 12",
      img: "../images/structureParts/nutbolt.webp",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 12mm)",
      val: "data.beam * 2",
      img: "../images/structureParts/nutbolt.webp",
    },
  ],
  "Single Carport": [
    {
      serialNo: "BHSMP201",
      name: "Customized",
      val: "data.totalStructure",
      img: "./images/icons/customized.webp",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMP01",
      name: "Polls",
      val: "data.polls",
      img: "../images/structureParts/polls.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength.toFixed(2)",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Rail_1755682500626.png",
    },
    {
      serialNo: "BHSMB01",
      name: "Beam",
      val: "data.beam",
      img: "../images/structureParts/beam.png",
    },
    {
      serialNo: "BHSMZC01",
      name: "Z Clamps",
      val: "data.beam * 12",
      img: "../images/structureParts/supportclamp.png",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 8mm)",
      val: "data.beam * 12",
      img: "../images/structureParts/nutbolt.webp",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 12mm)",
      val: "data.beam * 2",
      img: "../images/structureParts/nutbolt.webp",
    },
  ],
  "Double Carport": [
    {
      serialNo: "BHSMP201",
      name: "Customized",
      val: "data.totalStructure",
      img: "./images/icons/customized.webp",
    },
    {
      serialNo: "BHSMMC01",
      name: "Mid Clamp",
      val: "data.midClamp",
      img: "../images/structureParts/midClamp.png",
    },
    {
      serialNo: "BHSMEC01",
      name: "End Clamp",
      val: "data.endClamp",
      img: "../images/structureParts/endClamp.png",
    },
    {
      serialNo: "BHSMP01",
      name: "Polls",
      val: "data.polls",
      img: "../images/structureParts/polls.png",
    },
    {
      serialNo: "BHSMR01",
      name: "Rail Length",
      val: "data.railLength.toFixed(2)",
      img: "https://pvx-images.s3.me-south-1.amazonaws.com/Rail_1755682500626.png",
    },
    {
      serialNo: "BHSMB01",
      name: "Beam",
      val: "data.beam",
      img: "../images/structureParts/beam.png",
    },
    {
      serialNo: "BHSMZC01",
      name: "Z Clamps",
      val: "data.beam * 12",
      img: "../images/structureParts/supportclamp.png",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 8mm)",
      val: "data.beam * 12",
      img: "../images/structureParts/nutbolt.webp",
    },
    {
      serialNo: "BHSMNL01",
      name: "Nutbolts(110mm x 12mm)",
      val: "data.beam * 2",
      img: "../images/structureParts/nutbolt.webp",
    },
  ],
};
